import { render } from "./WiseBackButton.vue?vue&type=template&id=cc697578"
import script from "./WiseBackButton.vue?vue&type=script&lang=js"
export * from "./WiseBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__